export default __webpack_public_path__ + "static/Animation-23b65849ec1d1b759e0e5839ba443110.mp4";